/**
 * Labstep
 *
 * @module core/DataGrid/ColumnHeader/EntityImport
 * @desc DataGrid Header for EntityImport
 */

import { DataGridColumnHeaderEntityImportMetadataActionCreate } from 'labstep-web/core/DataGrid/ColumnHeader/EntityImport/Metadata/Action/Create';
import { DataGridColumnHeaderEntityImportMetadataActionDelete } from 'labstep-web/core/DataGrid/ColumnHeader/EntityImport/Metadata/Action/Delete';
import { DataGridColumnHeaderEntityImportMetadataActionMatch } from 'labstep-web/core/DataGrid/ColumnHeader/EntityImport/Metadata/Action/Match';
import { Dropdown } from 'labstep-web/core/Dropdown';
import { DropdownPortal } from 'labstep-web/core/Dropdown/Portal';
import type { EntityImportColDef } from 'labstep-web/models/entity-import.model';
import type React from 'react';
import type { IDataGridColumnHeaderEntityImportMetadataProps } from './types';

export const DataGridColumnHeaderEntityImportMetadata: React.FC<
  IDataGridColumnHeaderEntityImportMetadataProps
> = ({ trigger, context, column }) => {
  const { template, targetEntityName } = context;
  const { isCustom, isRequired } =
    column.getColDef() as EntityImportColDef;
  return (
    <DropdownPortal trigger={trigger}>
      {isCustom && template && (
        <>
          <DataGridColumnHeaderEntityImportMetadataActionMatch
            column={column}
            template={template}
            targetEntityName={targetEntityName}
          />
          <DataGridColumnHeaderEntityImportMetadataActionCreate
            column={column}
            template={template}
            targetEntityName={targetEntityName}
          />
          <Dropdown.Divider />
        </>
      )}
      {/* {!isRequired && (
        <DataGridColumnHeaderEntityImportMetadataActionDelete
          column={column}
        />
      )} */}
    </DropdownPortal>
  );
};
